// extracted by mini-css-extract-plugin
export default {"root":"page-footer_root__dJHnA"};